import React from 'react'
import * as Layout from '../../components/layout'

export const routes = [
  {
    action: (context: any) => import(/* webpackChunkName:  "CommunityConfigPage" */'./component')
      .then(({CommunityConfigPageConnected}) => <Layout.Layout>
        <CommunityConfigPageConnected communityIdentifier={context.params.communityIdentifier} />
      </Layout.Layout>),
    path: `/community/config/:communityIdentifier`,
  },
]



// WEBPACK FOOTER //
// ./src/pages/community-config/routes.tsx